import React from 'react'
import styles from './faq.module.scss'

export default ({ data }) => (
  <ul className={styles.faq}>
    {data.map(({ id, question, answer }) => (
      <li key={id} className={styles.faq__item}>
        <strong className={styles.faq__question}>Q: {question}</strong>
        <div
          className={styles.faq__answer}
          dangerouslySetInnerHTML={{
            __html: answer,
          }}
        />
      </li>
    ))}
  </ul>
)
